import { css } from '@emotion/react';
import { transformToSelectOptions } from 'screens/booker/screens/request/forms/RequestForm';

import { format } from 'date-fns';
import {
	QUERY_ARTISTS,
	QUERY_REQUEST_DATA,
	MUTATION_UPDATE_DATA_EVENT,
} from 'queries/queries-booking';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQuery } from 'urql';
import { Button } from '../../../components/Button';
import { FormControl } from '../../../components/FormControl';
import { FormFooter } from '../../../components/FormFooter';
import { FormLine } from '../../../components/FormLine';
import { FormSection } from '../../../components/FormSection';
import { FormSectionHeading } from '../../../components/FormSectionHeading';
import { Heading } from '../../../components/Heading';
import { Input } from '../../../components/Input';
import { confirmedRedirect } from '../helpers/helpers';
import { useStep } from '../hooks/useStep';

import { PreffiledValue } from '../components/PreffiledValue';
import { SpinnerBlock } from 'components/SpinnerBlock';
import { nonEmptyValidation, urlGoogleMapsValidation, zipValidation } from '../forms/validations';
import { useStore } from 'hooks/useStore';

enum FORM_EVENT {
	NAME = 'event_name',
	DATE = 'event_date',
	ARTIST = 'artist_id',
	ADDRESS_PLACE = 'event_address_place',
	ADDRESS_STREET = 'event_address_street',
	ADDRESS_CITY = 'event_address_city',
	ADDRESS_ZIP = 'event_address_zip',
	ADDRESS_GPS = 'event_address_gps',
}

export const EventStep = () => {
	const { id } = useStep();
	const navigate = useNavigate();

	const [queryRequestData] = useQuery({
		query: QUERY_REQUEST_DATA,
		variables: {
			url: id,
		},
	});

	// if confirmed -> redirect to TimesStep

	useEffect(() => {
		if (!queryRequestData.fetching) {
			confirmedRedirect(id, queryRequestData.data.request.confirmed, navigate);
		}
	}, [queryRequestData.data]);

	return (
		<div
			css={css`
				width: 560px;
			`}
		>
			<Heading title="Informace o akci" />
			{queryRequestData.fetching ? (
				<SpinnerBlock />
			) : (
				<Form defaultValues={queryRequestData?.data?.request} url={id} />
			)}
		</div>
	);
};

const Form = ({ defaultValues, url }) => {
	const { notifications } = useStore();

	const [artists, executeArtists] = useQuery({
		query: QUERY_ARTISTS,
		variables: {
			url: url,
		},
	});

	const artistsOptions = transformToSelectOptions(artists.data?.artists, 'name');

	const { goNextStep, goPrevStep } = useStep();

	const labelWidth = 200;

	const localDefaultValues = {
		artist_id: defaultValues?.artist?.id,
		event_name: defaultValues?.event_name,
		event_date: defaultValues?.event_date,
		event_address_place: defaultValues?.event_address_place,
		event_address_street: defaultValues?.event_address_street,
		event_address_city: defaultValues?.event_address_city,
		event_address_zip: defaultValues?.event_address_zip,
		event_address_gps: defaultValues?.event_address_gps,
	};

	console.log('prefilled', defaultValues);

	console.log(defaultValues?.artist?.id);

	const {
		handleSubmit,
		register,
		control,
		formState: { errors },
	} = useForm({
		defaultValues: localDefaultValues,
	});

	// Submit Form
	const [updateDataEvent, executeUpdateDataEvent] = useMutation(MUTATION_UPDATE_DATA_EVENT);

	const onSubmit = (data: any) => {
		console.log('SUBMIT');
		console.log(data);

		executeUpdateDataEvent({
			url: url,
			input: data,
		}).then((result) => {
			console.log(result);

			if (result?.error) {
				// VYHODIT ERROR
				return false;
			} else {
				notifications.addNotification({ message: 'Uloženo' });
			}

			goNextStep();
		});
	};

	if (artists.fetching) return <SpinnerBlock />;

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<FormSection>
				<FormLine first>
					<FormControl
						required
						label="Název akce"
						htmlFor={FORM_EVENT.NAME}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.NAME]}
					>
						<Input
							placeholder="Zadejte název akce..."
							{...register(
								FORM_EVENT.NAME,
								nonEmptyValidation({ required: 'Zadejte název akce.' }),
							)}
							error={!!errors[FORM_EVENT.NAME]}
						/>
					</FormControl>
				</FormLine>
				<FormLine>
					<FormControl
						required
						label="Interpret"
						htmlFor={FORM_EVENT.ARTIST}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ARTIST]}
						value={defaultValues?.artist?.name}
					>
						<PreffiledValue>{defaultValues?.artist?.name}</PreffiledValue>

						{/* {defaultValues.prefilled ? (
							<PreffiledValue>{defaultValues?.artist?.name}</PreffiledValue>
						) : (
							<Controller
								name={FORM_EVENT.ARTIST}
								control={control}
								rules={{ required: 'Vyberte interpreta.' }}
								render={({ field }) => {
									return (
										<Select
											{...field}
											options={artistsOptions}
											placeholder="Vyberte interpreta..."
											error={errors[FORM_EVENT.ARTIST]}
										/>
									);
								}}
							/>
						)} */}
					</FormControl>
				</FormLine>
				<FormLine>
					<FormControl
						required
						label="Datum"
						htmlFor={FORM_EVENT.DATE}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.DATE]}
						value={format(new Date(defaultValues[FORM_EVENT.DATE]), 'dd. MM. YYY')}
					>
						<PreffiledValue>
							{format(new Date(defaultValues[FORM_EVENT.DATE]), 'dd.MM.YYY')}
						</PreffiledValue>
						{/* {defaultValues.prefilled ? (
							<PreffiledValue>
								{format(new Date(defaultValues[FORM_EVENT.DATE]), 'dd.MM.YYY')}
							</PreffiledValue>
						) : (
							<Controller
								name={FORM_EVENT.DATE}
								control={control}
								rules={{ required: 'Vyberte datum.' }}
								render={({ field }) => {
									const { onChange } = field;

									const changeWithToggle = (date, toggle) => {
										const dateValue = format(date, 'YYY-MM-dd');

										onChange(dateValue);
										toggle();
									};

									return (
										<DatePicker
											renderTrigger={({ isOpen }) => (
												<div
													css={css`
														height: 44px;
														border: 1px solid #d4d5de;
														border-radius: 8px;
														padding: 12px;
														font-size: 14px;
														line-height: 20px;
														position: relative;

														padding-left: 44px;
														padding-right: 20px;

														&:hover {
															background: ${theme.colors.primary['50']};
															cursor: pointer;
														}

														${isOpen &&
														css`
															outline: none;
															box-shadow: 0 0 0 2px ${theme.colors.primary['400']};
															border-color: transparent;
														`}

														${errors[FORM_EVENT.DATE] &&
														css`
															border-color: #ff6767;
														`}

														${!field.value &&
														css`
															color: #8c8fa6;
														`}
													`}
												>
													<div
														css={css`
															position: absolute;
															top: 10px;
															left: 12px;
														`}
													>
														<IconCalendar />
													</div>

													{field.value
														? format(new Date(field.value), 'dd.MM.YYY')
														: 'Vyberte datum...'}
												</div>
											)}
											{...field}
											onChange={changeWithToggle}
										/>
									);
								}}
							/>
						)} */}
					</FormControl>
				</FormLine>

				<FormSectionHeading>Adresa</FormSectionHeading>

				<FormLine first>
					<FormControl
						required
						label="Místo"
						htmlFor={FORM_EVENT.ADDRESS_PLACE}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ADDRESS_PLACE]}
						readOnly={!defaultValues.prefill}
						value={defaultValues[FORM_EVENT.ADDRESS_PLACE]}
					>
						<PreffiledValue>{defaultValues[FORM_EVENT.ADDRESS_PLACE]}</PreffiledValue>
						{/* {defaultValues.prefilled ? (
							<PreffiledValue>{defaultValues[FORM_EVENT.ADDRESS_PLACE]}</PreffiledValue>
						) : (
							<Input
								placeholder="Na jakém místě se akce koná..."
								{...register(FORM_EVENT.ADDRESS_PLACE, { required: 'Zadejte místo konání akce.' })}
								error={!!errors[FORM_EVENT.ADDRESS_PLACE]}
							/>
						)} */}
					</FormControl>
				</FormLine>

				<FormLine>
					<FormControl
						required
						label="Ulice"
						htmlFor={FORM_EVENT.ADDRESS_STREET}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ADDRESS_STREET]}
					>
						<Input
							placeholder="Ulice místa konání..."
							{...register(
								FORM_EVENT.ADDRESS_STREET,
								nonEmptyValidation({ required: 'Zadejte ulici místa konání akce.' }),
							)}
							error={!!errors[FORM_EVENT.ADDRESS_STREET]}
						/>
					</FormControl>
				</FormLine>

				<FormLine>
					<FormControl
						required
						label="Město"
						htmlFor={FORM_EVENT.ADDRESS_CITY}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ADDRESS_CITY]}
						value={defaultValues?.event_address_city}
					>
						<PreffiledValue>{defaultValues[FORM_EVENT.ADDRESS_CITY]}</PreffiledValue>
						{/* {defaultValues.prefilled ? (
							<PreffiledValue>{defaultValues[FORM_EVENT.ADDRESS_CITY]}</PreffiledValue>
						) : (
							<Input
								placeholder="V jakém měste se akce koná..."
								{...register(FORM_EVENT.ADDRESS_CITY, {
									required: 'Zadejte město místa konání akce.',
								})}
								error={!!errors[FORM_EVENT.ADDRESS_CITY]}
							/>
						)} */}
					</FormControl>
				</FormLine>

				<FormLine>
					<FormControl
						required
						label="PSČ"
						htmlFor={FORM_EVENT.ADDRESS_ZIP}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ADDRESS_ZIP]}
					>
						<Input
							{...register(
								FORM_EVENT.ADDRESS_ZIP,

								zipValidation({
									required: 'Zadejte PSČ místa konání.',
								}),
							)}
							error={!!errors[FORM_EVENT.ADDRESS_ZIP]}
							width={80}
						/>
					</FormControl>
				</FormLine>

				<FormLine>
					<FormControl
						required
						label="GPS Souřadnice"
						desc="URL odkaz na Google Maps"
						htmlFor={FORM_EVENT.ADDRESS_GPS}
						labelWidth={labelWidth}
						error={errors[FORM_EVENT.ADDRESS_GPS]}
					>
						<Input
							placeholder="https://"
							{...register(
								FORM_EVENT.ADDRESS_GPS,
								urlGoogleMapsValidation({
									required: 'Zadejte URL odkaz na Google Maps.',
									url: 'Neplatný URL odkaz na Google Maps.',
								}),
							)}
							error={!!errors[FORM_EVENT.ADDRESS_GPS]}
						/>
					</FormControl>
				</FormLine>
			</FormSection>

			<FormFooter>
				<Button outline type="button" onClick={() => goPrevStep()}>
					Zpět
				</Button>

				<Button type="submit" isProcessing={updateDataEvent.fetching}>
					Uložit a pokračovat
				</Button>
			</FormFooter>
		</form>
	);
};
